
export { useWalletConnectContext } from "/home/runner/work/capsicum/capsicum/libs/socios-core/web/wallet-connect/provider/walletConnectContext.ts"